import React from 'react';
import Sidebar from '../../components/sidebars/Sidebar';
import RootLayout from './RootLayout';
import { cn } from '../../lib/helpers.ts';
import { Drawer } from 'vaul';
import clsx from 'clsx';
import { Button } from '../../components/buttons/Button.tsx';
import { IconBars } from '../../components/Icon.tsx';
import UrlTriggeredAlert from '../containers/UrlTriggeredAlert.tsx';

export default function AuthLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <RootLayout>
            <Drawer.Root direction="left" handleOnly={true} noBodyStyles={true}>
                <div className="min-h-screen w-full bg-base-100">
                    <Drawer.Portal>
                        <Drawer.Overlay className="fixed inset-0 bg-black/40" />
                        <Drawer.Content className="fixed inset-0 w-56">
                            <Sidebar />
                        </Drawer.Content>
                    </Drawer.Portal>

                    {/* Always shown sidebar on PC */}
                    <Sidebar className="hidden lg:flex" />

                    <div className={cn('pl-0 lg:pl-56')}>
                        <div
                            className={clsx(
                                'mx-auto box-content max-w-6xl pt-4',
                                'px-4 sm:px-8 md:px-10'
                            )}
                        >
                            {/* TODO: check if this could be main tag and wrap children in it? */}
                            <Drawer.Trigger className="flex lg:hidden">
                                <Button color="product" variant="secondary">
                                    <IconBars size={20} className="me-2" />
                                    Menu
                                </Button>
                            </Drawer.Trigger>
                        </div>
                        <UrlTriggeredAlert />
                        {children}
                    </div>
                </div>
            </Drawer.Root>
        </RootLayout>
    );
}
